import React, { FC } from 'react';
import { DailySalesData } from './types';

interface DailySalesChartProps {
  data?: DailySalesData | null;
}

const fmt = (n: number) =>
  n >= 1000 ? `$${(n / 1000).toFixed(1)}k` : `$${Number(n).toFixed(0)}`;

const DailySalesChart: FC<DailySalesChartProps> = ({ data }) => {
  if (!data?.days_of_week?.length) return null;

  const days = data.days_of_week;
  const maxSales = Math.max(...days.map(d => Number(d.sales)), 1);
  const totalSales = days.reduce((sum, d) => sum + Number(d.sales), 0);

  return (
    <div className="bg-white rounded-3 shadow-sm p-4 h-100" style={{ border: '1px solid #f0f0f0' }}>
      <div className="d-flex align-items-center justify-content-between mb-4">
        <h6 className="fw-bold mb-0" style={{ color: '#1a1a2e', fontSize: 12, textTransform: 'uppercase', letterSpacing: '0.06em' }}>
          Revenue — Last 7 Days
        </h6>
        <span className="fw-bold" style={{ fontSize: 15, color: '#163172' }}>{fmt(totalSales)}</span>
      </div>

      <div className="d-flex align-items-end justify-content-between gap-1" style={{ height: 80 }}>
        {days.map((d, i) => {
          const sales = Number(d.sales);
          const heightPct = maxSales > 0 ? (sales / maxSales) * 100 : 0;
          const isToday = i === days.length - 1;
          return (
            <div key={i} className="d-flex flex-column align-items-center flex-grow-1 gap-1">
              {sales > 0 && (
                <span style={{ fontSize: 9, color: '#94a3b8', fontWeight: 600 }}>{fmt(sales)}</span>
              )}
              <div
                className="rounded-2 w-100"
                style={{
                  height: `${Math.max(heightPct, 4)}%`,
                  minHeight: 4,
                  background: isToday ? '#163172' : sales > 0 ? '#bfcbf0' : '#f1f5f9',
                  transition: 'height 0.4s ease',
                }}
                title={`${d.day}: ${fmt(sales)}`}
              />
              <span style={{ fontSize: 9, color: isToday ? '#163172' : '#94a3b8', fontWeight: isToday ? 700 : 500 }}>
                {d.day.slice(0, 2).toUpperCase()}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DailySalesChart;
